import React from "react";

import Text from "src/components/text";

import _ from "lodash";
import styles from "./styles.module.scss";
import { User } from "src/types/users";
import { Analytics } from "src/types/reports";

const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";

export interface ShareListItem {
  user: User;
  analytics: Analytics;
}

export interface TopSharersListCardProps {
  item: ShareListItem;
  columnCount: number;
}

export const TopSharersListCard: React.FC<TopSharersListCardProps> = ({
  item,
  columnCount,
}) => {
  const { user, analytics } = item;
  return (
    <div className={styles.tableRow}>
      <div className={styles.tableDataContainer}>
        <img
          src={user.icon?.thumbnail || DefaultAssetIcon}
          className={`${styles.thumbnailIcon} ${styles.contactIcon}`}
          alt={`${user.firstName} ${user.lastName}`}
        />
        <div className={styles.rightData}>
          <div className={styles.tableDataTitle}>
            <Text
              lines={1}
              className={styles.title}
              text={`${user.firstName} ${user.lastName}`}
            />
          </div>
        </div>
      </div>
      <div
        className={styles.analyticsContainer}
        style={{
          gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`,
        }}
      >
        <div className={styles.tableDataViews}>{analytics.shares}</div>
        <div className={styles.tableDataTime}>{analytics.assets}</div>
      </div>
    </div>
  );
};
